export const newsFiltersInitialState = {
  wordCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'wordCloudFilter',
    translateKey: 'filter:wordCloud',
  },
  sentimentFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValues: {
      positive: false,
      neutral: false,
      negative: false,
    },
    platform: 'news',
    componentName: 'sentimentFilter',
    translateKey: 'filter:contentsSentiment',
  },
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:contentBasedOn',
  },
  countryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'countryFilter',
    translateKey: 'filter:country',
  },
  languageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
  },
  // contentTypeFilter: {
  //   hasFilter: false,
  //   isOpen: false,
  //   selectedValue: 'both', // both or original or copy
  //   componentName: 'contentTypeFilter',
  //   translateKey: 'filter:contentType',
  // },
  contentCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    componentName: 'contentCategoryFilter',
    translateKey: 'filter:contentCategory',
    selectedCategories: {},
  },
  resourceTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'news',
    componentName: 'resourceTypeFilter',
    translateKey: 'filter:resourceType',
  },
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    platform: 'news',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    hasIncludeExclude: false,
    filterType: 'include',
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: false,
    platform: 'news',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
  },
};
